export default __webpack_public_path__ + "static/media/multicar10.e437666c.jpeg";